import Vue from "vue"
import { Auth } from "aws-amplify"
import Router from "vue-router"
import DashboardLayout from "@/layout/DashboardLayout"
import AuthLayout from "@/layout/AuthLayout"
import { store } from './store/store.js'
import '../node_modules/nprogress/nprogress.css';
import NProgress from 'nprogress'

Vue.use(Router)
const routes = [
  {
    name: "dashboard",
    path: "/admin",
    redirect: "/admin/dashboard",
    component: DashboardLayout,
    children: [
      {
        path: "/admin/dashboard",
        meta: {
          requiredAuth: true,
        },
        component: () => import("./views/Dashboard.vue"),
      },
      {
        path: "/restricted",
        name: "restricted",
        component: () => import("./views/Restricted.vue"),
      },
      {
        path: "/logout",
        name: "logout",
        meta: {
          requiredAuth: true,
        },
        component: () => import("./views/Logout.vue"),
      },
      {
        path: "/admin/giftaway/merchants",
        name: "merchants",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/GiveAwayMerchants.vue"),
      },
      {
        path: "/admin/giftaway/FlashPromoConfigs",
        name: "FlashPromoConfigs",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/FlashPromoProducts.vue"),
      },
      {
        path: "/admin/giftaway/GameConfiguration",
        name: "Game Configuration",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/GameConfiguration.vue"),
      },
      {
        path: "/admin/giftaway/PrizeItemConfig",
        name: "Prize Item Config",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/PrizeItemConfig.vue"),
      },
      {
        path: "/admin/giftaway/SpecialPrizeConditionConfig",
        name: "Special Prize Condition Config",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/SpecialPrizeConditionReactConfig.vue"),
      },
      {
        path: "/admin/giftaway/GlobalPromoConfig",
        name: "Promo Config",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/GlobalPromoConfig.vue"),
      },
      {
        path: "/admin/giftaway/GlobalPromoRules",
        name: "Rules Config",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/GlobalPromoRules.vue"),
      },
      {
        path: "/admin/giftaway/GlobalPromoTrigger",
        name: "Trigger Config",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/GlobalPromoTrigger.vue"),
      },
      {
        path: "/admin/giftaway/PromoterConfig",
        name: "Promoter Config",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/PromoterConfig.vue"),
      },
      {
        path: "/admin/giftaway/DailyLoginReport",
        name: "Daily Login Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/DailyLoginReport.vue"),
      },
      {
        path: "/admin/giftaway/GameLeaderboardReport",
        name: "Game Leaderboard Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/GameLeaderboardReport.vue"),
      },
      {
        path: "/admin/giftaway/GameDailyPlayReport",
        name: "Game Daily Play Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/GameDailyPlayReport.vue"),
      },
      {
        path: "/admin/giftaway/LASDonationReport",
        name: "LAS Donation Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/LASDonationReport.vue"),
      },
      {
        path: "/admin/giftaway/EMSTrackingUPCMultiplyReport",
        name: "EMS Tracking UPC Multiply Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/EMSTrackingUPCMultiplyReport.vue"),
      },
      {
        path: "/admin/giftaway/LASActivityRewardTransactionReport",
        name: "LAS Activity Reward Transaction Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () =>
          import("./views/LASActivityRewardTransactionReport.vue"),
      },
      {
        path: "/admin/giftaway/ShippingReceiptReport",
        name: "Shipping Receipt Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/ShippingReceiptReport.vue"),
      },
      {
        path: "/admin/giftaway/UGCArtworkVotesReport",
        name: "UGC Artwork Votes Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/UGCArtworkVotesReport.vue"),
      },
      {
        path: "/admin/giftaway/UGCArtworkContestReport",
        name: "UGC Artwork Contest Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/UGCArtworkContestReport.vue"),
      },
      {
        path: "/admin/giftaway/AuditTrailAPIReport",
        name: "Audit Trail API Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/AuditTrailApiReport.vue"),
      },
      {
        path: "/admin/giftaway/BlockUserApiReport",
        name: "Block User API Report",
        meta: {
          requiredAuth: true,
          blockUserApiAccess: true,
        },
        component: () => import("./views/BlockUserApiReport.vue"),
      },
      {
        path: "/admin/giftaway/SchedulerProcessReport",
        name: "Scheduler Process Report",
        meta: {
          requiredAuth: true,
          blockUserApiAccess: true,
        },
        component: () => import("./views/SchedulerProcessReport.vue"),
      },
      {
        path: "/admin/giftaway/SchedulerReProcessReport",
        name: "Scheduler Re Process Report",
        meta: {
          requiredAuth: true,
          blockUserApiAccess: true,
        },
        component: () => import("./views/SchedulerReProcessReport.vue"),
      },
      {
        path: "/admin/giftaway/GlobalPromoTransactionReport",
        name: "Global Promo Transaction Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/GlobalPromoTransactionReport.vue"),
      },
      {
        path: "/admin/giftaway/UPCTransactionReport",
        name: "UPC Transaction Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/UPCTransactionReport.vue"),
      },
      {
        path: "/admin/giftaway/UPCLASClassificationReport",
        name: "UPC LAS Classification Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/UPCLASClassificationReport.vue"),
      },
      {
        path: "/admin/giftaway/transaction",
        name: "transaction",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/GiftAwayTransaction.vue"),
      },
      {
        path: "/admin/giftaway/report",
        name: "transaction_report",
        meta: {
          requiredAuth: true,
        },
        component: () => import("./views/GiftAwayTransactionSummaryReport.vue"),
      },
      {
        path: "/admin/giftaway/AffiliatorReferralCodeReport",
        name: "Affiliator Referral Code Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/AffiliatorReferralCodeReport.vue"),
      },
      {
        path: "/admin/giftaway/ReferralUsersReport",
        name: "Referral Users Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/ReferralUsersReport.vue"),
      },
      {
        path: "/admin/giftaway/UPCConsumerBlockReport",
        name: "UPC Consumer Block Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/UPCConsumerBlockReport.vue"),
      },
      {
        path: "/admin/giftaway/ContentViewReport",
        name: "Content View Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/ContentViewReport.vue"),
      },
      {
        path: "/admin/config",
        name: "Global Configuration",
        meta: {
          requiredAuth: true,
          onlyAdmin: true,
        },
        component: () => import("./views/GlobalConfiguration.vue"),
      },
      {
        path: "/admin/raffle/RaffleEvent",
        name: "Raffle Event",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/RaffleEvent.vue"),
      },
      {
        path: "/admin/raffle/RaffleEventWinner",
        name: "Raffle Event Winner",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/RaffleEventWinner.vue"),
      },
      {
        path: "/admin/provinceCity/ProvinceCity",
        name: "Province City",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/ProvinceCity.vue"),
      },
      {
        path: "/admin/giftaway/AccountStatusReport",
        name: "Account Status",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/AccountStatusReport.vue"),
      },
      {
        path: "/admin/giftaway/JustScanReport",
        name: "Just Scan Registration Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/JustScanReport.vue"),
      },
      {
        path: "/admin/userTask/UserTaskConfig",
        name: "User Task Config",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/UserTaskConfig.vue"),
      },
      {
        path: "/admin/userTask/UserTaskReactionConfig",
        name: "User Task Reaction Config",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/UserTaskReactionConfig.vue"),
      },
      {
        path: "/admin/userTask/UserTaskResponseConfig",
        name: "User Task Response Config",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/UserTaskResponseConfig.vue"),
      },
      {
        path: "/admin/userTask/UserTaskRulesConfig",
        name: "User Task Rules Config",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/UserTaskRulesConfig.vue"),
      },
      {
        path: "/admin/stream",
        meta: {
          requiredAuth: true,
        },
        component: () => import("./views/StreamConfig.vue"),
      },
      {
        path: "/admin/giftaway/ChestPrizeReport",
        name: "Chest Prize Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/ChestPrizeReport.vue"),
      },
      {
        path: "/admin/raffle/ConsumerRaffleSpecialReport",
        name: "Consumer Raffle Special Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/ConsumerRaffleSpecialReport.vue"),
      },
      {
        path: "/admin/raffle/ConsumerRaffleSpecialEventWinnerReport",
        name: "Consumer Raffle Special Event Winner Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () =>
          import("./views/ConsumerRaffleSpecialEventWinnerReport.vue"),
      },
      {
        path: "/admin/giftaway/UserTaskTransactionReport",
        name: "UserTask Transaction Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () =>
          import("./views/UserTaskReportPage.vue"),
      },
      {
        path: "/admin/giftaway/UserTaskReactionTransactionReport",
        name: "UserTask Reaction Transaction Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () =>
          import("./views/UserTaskReactionReportPage.vue"),
      },
      {
        path: "/admin/giftaway/UserTaskResponseTransactionReport",
        name: "UserTask Response Transaction Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () =>
          import("./views/UserTaskResponseReportPage.vue"),
      },
      {
        path: "/admin/giftaway/RoleMappingConfig",
        name: "Role Mapping Config",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/RoleMappingConfig.vue"),
      },
      {
        path: "/admin/giftaway/AccessLogReport",
        name: "Access Log Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/AccessLogReport.vue"),
      },
      {
        path: "/admin/giftaway/VeratadFailedLogReport",
        name: "Veratad Failed Log Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/VeratadFailedLogReport.vue"),
      },
      {
        path: "/admin/giftaway/ACSLogReport",
        name: "ACS Log Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/ACSLogReport.vue"),
      },
      {
        path: "/admin/giftaway/RegistrationACSStatusReport",
        name: "Registration ACS Status Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/RegistrationACSStatusReport.vue"),
      },
      {
        path: "/admin/giftaway/SummarizeConsumerReport",
        name: "Summarize Consumer Report",
        meta: {
          requiredAuth: true,
          onlyGiftawayAccess: true,
        },
        component: () => import("./views/SummarizeConsumerReport.vue"),
      },
    ],
  },
  {
    path: "/",
    redirect: "login",
    component: AuthLayout,
    children: [
      {
        path: "/login",
        name: "login",
        meta: {
          requiredNonAuth: true,
        },
        component: () => import("./views/Login.vue"),
      },
    ],
  },
];

const router = new Router({
  linkExactActiveClass: "active",
  routes: routes,
  mode: 'history'
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
  }
  if (to.matched.some((record) => record.meta.requiredAuth)) {
    Auth.currentAuthenticatedUser()
      .then(() => {
        if (to.matched.some((record) => record.meta.onlyAdmin)) {
          try {
            if (!store.getters['isLoginUserAdmin']) {
              next({
                path: "/restricted",
              })
            }
          } catch {
            next({
              path: "/",
            })
          }
        }
        if(to.matched.some((record) => record.meta.onlyGiftawayAccess)){
          try {
            if (store.getters.roleMappingData.filter((item) => store.getters.loginUser.groups.includes(item)))
            {
              next();
            } else {
              next({
                path: "/restricted",
              });
            }
          } catch {
            next({
              path: "/",
            })
          }
        }
		//onlyGiftawayAccess + vendorHotlineAccess
		if (to.matched.some((record) => record.meta.blockUserApiAccess)) {
			try {
        if (store.getters.roleMappingData.filter((item) => store.getters.loginUser.groups.includes(item)))
        {
          next();
        } else {
          next({
            path: "/restricted",
          });
        }
			} catch {
				next({
					path: "/",
				})
			}
		}
        next()

      })
      .catch(() => {
        next({
          path: "/login",
        })
      })
  }
  if (to.matched.some((record) => record.meta.requiredNonAuth)) {
    Auth.currentAuthenticatedUser()
      .then(() => {
        next({
          path: "/admin/dashboard",
        })
      })
      .catch(() => {
        next()
      })
  }
  next()
});

router.afterEach(() => {
  NProgress.done()
});

export default router
